export default __webpack_public_path__ + "static/dash_icon-ece77691b6f3916df4e0a38b4217a1b5.svg";